/** Where transcript_excerpts marks a matched word: chr(2) and chr(3). */
export const MARK_START = "";
export const MARK_END = "";

export type ExcerptPart = { text: string; marked: boolean };

/**
 * An excerpt split into plain and highlighted runs. The markers are control
 * characters the database adds, so nothing in the text is parsed as HTML. A
 * marker without its partner is dropped rather than highlighting the rest of
 * the excerpt.
 */
export const excerptParts = (excerpt: string): ExcerptPart[] => {
  const parts: ExcerptPart[] = [];
  const strip = (text: string) =>
    text.split(MARK_START).join("").split(MARK_END).join("");
  const push = (text: string, marked: boolean) => {
    if (!text) return;
    const last = parts[parts.length - 1];
    if (last && last.marked === marked) last.text += text;
    else parts.push({ text, marked });
  };
  let rest = excerpt;
  while (rest.length) {
    const start = rest.indexOf(MARK_START);
    if (start === -1) {
      push(strip(rest), false);
      break;
    }
    push(strip(rest.slice(0, start)), false);
    const end = rest.indexOf(MARK_END, start + 1);
    if (end === -1) {
      push(strip(rest.slice(start + 1)), false);
      break;
    }
    push(strip(rest.slice(start + 1, end)), true);
    rest = rest.slice(end + 1);
  }
  return parts;
};

/** Splits ids into chunks, so each newly loaded page fetches only its own. */
export const chunk = <T>(items: T[], size: number): T[][] => {
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
};
